import React from "react";
import styled from "styled-components";
import { tokens } from "../../../../../public/tokens";

const StyledStatus = styled.span(({ $isReady }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: tokens.globals["spacing-1-5"],
    color: $isReady ? tokens.colors.states.success["500"] : tokens.colors.ui.destructive,
    fontSize: tokens.typography.fontSize["sm-10px"],
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontWeight: tokens.typography.fontWeights.semibold,
    lineHeight: 1,

    i: {
        fontSize: tokens.typography.fontSize["sm-10px"],
    },
}));

/**
 * "N Unassigned Modules" status used on Versions list cards (and reusable on
 * Programmes/Study Paths, which must show the same count using the same rule).
 * @param {number} count Unassigned-module count; 0 renders a ready state, never blank space.
 */
function UnassignedModulesStatus({ count = 0 }) {
    const isReady = count === 0;

    return (
        <StyledStatus $isReady={isReady} aria-label={`${count} Unassigned Modules`}>
            <i
                className={isReady ? "fas fa-check-circle" : "fas fa-exclamation-triangle"}
                aria-hidden="true"
            />
            {count} Unassigned Modules
        </StyledStatus>
    );
}

export default UnassignedModulesStatus;
